import { Input } from '@/components/ui/input'
import { CharacterCount, Label } from '@/components/ui/label'
import { T, useTranslate } from '@tolgee/react'
import { Field } from 'react-final-form'
import { MAX_SERVICE_NAME_LENGTH } from '../../_utils/constants'

interface NameFieldProps {
  disabled?: boolean
}

export function NameField({ disabled = false }: NameFieldProps) {
  const { t } = useTranslate()

  return (
    <Field name='name'>
      {({ input }) => (
        <div>
          <Label htmlFor={input.name} variant='dialog-field'>
            <T keyName='serviceRegistry.dialog.fields.name.label' />*
          </Label>
          <div className='flex flex-col gap-2'>
            <Input
              placeholder={t('serviceRegistry.dialog.fields.name.placeholder')}
              maxLength={MAX_SERVICE_NAME_LENGTH}
              disabled={disabled}
              required
              {...input}
            />
            <CharacterCount length={input.value.length} max={MAX_SERVICE_NAME_LENGTH} />
          </div>
        </div>
      )}
    </Field>
  )
}
